module.exports = __webpack_public_path__ + "img/line-plug.f7c4363b.svg";